import { motion } from "framer-motion";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import { Image } from "@/components/ui/image";
// ✅ Imports de imágenes locales
import pazTranquilidad from "@/assets/images/experiencias/paz-tranquilidad.png";
import gastronomiaAutor from "@/assets/images/experiencias/gastronomia-autor.png";
import naturalezaAventura from "@/assets/images/experiencias/naturaleza-aventura.png";
import atardeceresPrivados from "@/assets/images/experiencias/atardeceres-privados.png";

const EXPERIENCES = [
  {
    title: "Paz & Tranquilidad",
    desc: "Zona completamente aislada de ruido de ciudad.",
    image: pazTranquilidad,
  },
  {
    title: "Gastronomía de Autor",
    desc: "Experiencias culinarias con ingredientes locales de temporada.",
    image: gastronomiaAutor,
  },
  {
    title: "Naturaleza & Aventura",
    desc: "Senderismo, paseos tranquilos y exploración del entorno natural.",
    image: naturalezaAventura,
  },
  {
    title: "Atardeceres Privados",
    desc: "Momentos únicos contemplando el horizonte desde espacios exclusivos y cómodos.",
    image: atardeceresPrivados,
  },
];

export default function Experiencias() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section id="experiencias" ref={ref} className="py-28 md:py-40 px-6 lg:px-10 bg-background">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <motion.span
            initial={{ opacity: 0 }}
            animate={isVisible ? { opacity: 1 } : {}}
            transition={{ duration: 1 }}
            className="text-accent text-sm tracking-[0.3em] uppercase font-light mb-6 block"
          >
            Experiencias
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            animate={isVisible ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 1.2, delay: 0.1 }}
            className="font-serif-display text-4xl md:text-5xl lg:text-6xl font-light text-foreground text-balance"
          >
            Momentos que trascienden
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {EXPERIENCES.map((exp, i) => (
            <motion.div
              key={exp.title}
              initial={{ opacity: 0, y: 40 }}
              animate={isVisible ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 1, delay: 0.2 + i * 0.1 }}
              className="group relative aspect-[4/3] overflow-hidden cursor-pointer"
            >
              <Image
                src={exp.image}
                alt={exp.title}
                className="w-full h-full transition-transform duration-700 group-hover:scale-105"
                fittingType="fill"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-8 translate-y-2 group-hover:translate-y-0 transition-transform duration-500">
                <h3 className="font-serif-display text-2xl md:text-3xl text-white font-light mb-2">
                  {exp.title}
                </h3>
                <p className="text-white/70 text-sm font-light max-w-md opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  {exp.desc}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}